export function aiScheduleDue(frequency: string, taipei: { weekday: number; day: number }) {
  if (frequency === "daily") return true;
  if (frequency === "weekly") return taipei.weekday === 1;
  if (frequency === "monthly") return taipei.day === 1;
  return false;
}
export type MonitoringRun = { id: number; keywordId: number; provider: string; status: string; finishedAt: Date | string; errorMessage: string | null };
export function summarizeMonitoring(runs: MonitoringRun[], keywordIds: number[]) {
  const tracked = new Set(keywordIds);
  const time = (value: Date | string) => value instanceof Date ? value.getTime() : Date.parse(value.includes("T") ? value : value.replace(" ", "T") + "Z");
  const latest = new Map<string, MonitoringRun>();
  for (const run of runs) {
    if (!tracked.has(run.keywordId)) continue;
    const key = `${run.provider}:${run.keywordId}`;
    const previous = latest.get(key);
    if (!previous || time(run.finishedAt) > time(previous.finishedAt) || (time(run.finishedAt) === time(previous.finishedAt) && run.id > previous.id)) latest.set(key,run);
  }
  return ["aio","gemini","chatgpt"].map(provider => {
    const rows = Array.from(latest.values()).filter(row=>row.provider===provider);
    const successes = rows.filter(row=>row.status.startsWith("success_"));
    const errors = rows.filter(row=>row.status==="error").sort((a,b)=>time(b.finishedAt)-time(a.finishedAt) || b.id-a.id);
    const last = rows.sort((a,b)=>time(b.finishedAt)-time(a.finishedAt))[0];
    return { provider, checkedKeywords: successes.length, failedKeywords: errors.length, missingKeywords: tracked.size-rows.length,
      lastCheckedAt: last ? new Date(time(last.finishedAt)).toISOString() : null,
      latestError: errors[0]?.errorMessage || null };
  });
}

export function monitoringCoverageUnavailable(status: { checkedKeywords: number } | undefined, loading: boolean, error: boolean) {
  return loading || error || !status || status.checkedKeywords === 0;
}
